import { Place } from '../../../gk-dynamic-form/services/place/place.model';
import { Street } from '../../../gk-dynamic-form/services/street/street.model';

export enum PprfPropertyFormControlName {
  PropertyType = 'propertyType',
  RightType = 'rightType',
  ShareNumeratorFrom = 'shareNumeratorFrom',
  ShareDenominatorFrom = 'shareDenominatorFrom',
  ShareNumeratorTo = 'shareNumeratorTo',
  ShareDenominatorTo = 'shareDenominatorTo',
  LandRegistryAreaFrom = 'landRegistryAreaFrom',
  LandRegistryAreaTo = 'landRegistryAreaTo',
  Place = 'place',
  Street = 'street',
  Number = 'number',
  Slash = 'slash',
}

export class PprfPropertyFormModel {
  constructor(
    public propertyType: number[],
    public rightType: number[],
    public shareNumeratorFrom: number,
    public shareDenominatorFrom: number,
    public shareNumeratorTo: number,
    public shareDenominatorTo: number,
    public landRegistryAreaFrom: number,
    public landRegistryAreaTo: number,
    public place: Place,
    public street: Street,
    public number: string | number,
  ) {}

  static getEmptyModel(): PprfPropertyFormModel {
    return new this(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    );
  }

  getShareByRangesControl(): { from: string; to: string } {
    const formatShare = (numerator: number, denominator: number): string =>
      `${numerator}/${denominator}`;

    const fromShare =
      this.shareNumeratorFrom && this.shareDenominatorFrom
        ? formatShare(this.shareNumeratorFrom, this.shareDenominatorFrom)
        : undefined;
    const toShare =
      this.shareNumeratorTo && this.shareDenominatorTo
        ? formatShare(this.shareNumeratorTo, this.shareDenominatorTo)
        : undefined;

    if (fromShare && toShare) {
      const fromRatio = this.shareNumeratorFrom / this.shareDenominatorFrom;
      const toRatio = this.shareNumeratorTo / this.shareDenominatorTo;

      return fromRatio > toRatio
        ? { from: toShare, to: fromShare }
        : { from: fromShare, to: toShare };
    }

    return { from: fromShare, to: toShare };
  }
}

export const pprfPropertyFormModel = PprfPropertyFormModel.getEmptyModel();
